<template>
  <div>
    <component :is="component" />
  </div>
</template>

<script>
export default {
  name: "themezone",
  data() {
    return {
      component: ''
    }
  },
  created() {
    this.getComponent()
  },
  methods: {
    getComponent() {
      let type = this.$route.query.themetype
      let compnt = ''
      // 根据路由参数获取组件，不传默认显示"水煮酸汤主题专区"
      switch (type) {
        case 'poach':
          compnt = () => import('@/views/themezone/components/poach')
          break
        case 'cray':
          compnt = () => import('@/views/themezone/components/cray')
          break
        default:
          compnt = () => import('@/views/themezone/components/cray')
          break
      }
      this.component = compnt
    }
  }
}
</script>